import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Antd from "ant-design-vue";
import {
  Menu,
  MenuItem,
  Submenu,
  MenuItemGroup,
  Icon,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Dialog,
  Button,
  Input,
  Form,
  FormItem,
  MessageBox
} from "element-ui";
import "./config/antd";
import * as echarts from "echarts";

import "ant-design-vue/dist/antd.less";
import "./assets/style/global.less";

Vue.config.productionTip = false;

Vue.use(Antd);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Submenu);
Vue.use(MenuItemGroup);
Vue.use(Icon);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.prototype.$echarts = echarts;
Vue.prototype.$alert = MessageBox.alert;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
